import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    gridColumns: {
        display: "grid",
        width: "100%",
        gridTemplateColumns: "250px 1fr 250px",
        "& > div" : {
            padding: "0px 17px 17px 17px"
        },
        "& > div:first-of-type" : {
            borderRight: "1px solid " + theme.palette.grey.grey200
        },
        "& > div:last-of-type" : {
            borderLeft: "1px solid " + theme.palette.grey.grey200
        }
    }, 
    subTitle: {
        color: theme.palette.black.dark,
        fontSize: "16px",
        fontWeight: 600, 
        marginBottom: "5px"
    },
    flex: {
        display: "flex",
        gap: "8px",
        alignItems: "center"
    },
    score_bold: {
        fontWeight: 600,
        fontSize: "28px", 
        paddingRight: "4px"
    },
    depthDescription : {
        color: theme.palette.grey.grey500,
        fontSize: "14px",
        fontWeight: 400
    },
    globalDescription: {
        width: "100%",
        borderRadius: "4px",
        padding: "13px",
        marginTop: "17px",
        backgroundColor: theme.palette.grey.grey100
    }, 
    table_scores: {
        tableLayout: "auto",
        marginTop: "24px",
        width: "100%",
        border: "solid 2px " + theme.palette.grey.grey200,
        borderCollapse: "collapse",
        borderRadius: "8px",
        "& tbody": {
            fontSize: "12px",
            fontWeight: 400, 
            verticalAlign: "top"
        }, 
        "& td" : {
            padding: "0px 16px 4px 16px",
        }
    },
    table_scores_header: {
        color: theme.palette.grey.grey500,
        fontSize: "12px",
        fontWeight: 600,
        lineHeight: "20px",
        textAlign: "left", 
        "& th": {
            padding: "8px 16px",
            borderCollapse: "collapse",
            backgroundColor: theme.palette.grey.grey100
        }
    },
    topic_score : {
        fontSize: "14px", 
        fontWeight: "500",
        color: theme.palette.grey.grey700
    },
    content_bold: {
        fontWeight: 400, 
        fontSize: "12px", 
        color: theme.palette.grey.grey900
    }, 
    table_scores_theme_label: {
        color: theme.palette.grey.grey500,
        fontSize: "12px",
        fontWeight: "500",
    },
    table_scores_theme_score: {
        color: theme.palette.grey.grey500,
        padding: "4px 6px;",
        fontSize: "13px",
        width: "fit-content;"
    }, 
    topBorder: {
        "& > td": {
            borderTop: "1px solid " + theme.palette.grey.grey200,
            paddingTop: "4px"
        }
    }, 
    rightBorder : {
        borderRight: "1px solid " + theme.palette.grey.grey200,
        fontWeight: "500"
    },
    topicWidth: {
        minWidth: "250px"
    }
}))

export default useStyles;